import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious
} from '@/components/ui/pagination';

interface PaginationControlsProps {
  currentPage: number;
  endIndex: number;
  getPageNumbers: () => ('ellipsis' | number)[];
  itemLabel?: string;
  itemsPerPage: number;
  onNextPage: () => void;
  onPageClick: (page: number) => void;
  onPreviousPage: () => void;
  startIndex: number;
  totalItems: number;
  totalPages: number;
}

export function PaginationControls({
  currentPage,
  endIndex,
  getPageNumbers,
  itemLabel = 'items',
  itemsPerPage,
  onNextPage,
  onPageClick,
  onPreviousPage,
  startIndex,
  totalItems,
  totalPages
}: PaginationControlsProps) {
  if (totalItems <= itemsPerPage) {
    return null;
  }

  return (
    <div className="flex items-center justify-between pt-5">
      <div className="text-sm">
        Showing {startIndex + 1} to {Math.min(endIndex, totalItems)} of{' '}
        {totalItems} {itemLabel}
      </div>
      <Pagination className="mx-0 w-auto">
        <PaginationContent>
          <PaginationItem>
            <PaginationPrevious
              className="cursor-pointer"
              onClick={e => {
                e.preventDefault();
                if (currentPage > 1) onPreviousPage();
              }}
            />
          </PaginationItem>

          {getPageNumbers().map((page, idx) =>
            page === 'ellipsis' ? (
              <PaginationItem key={`ellipsis-${String(idx)}`}>
                <PaginationEllipsis />
              </PaginationItem>
            ) : (
              <PaginationItem key={page}>
                <PaginationLink
                  className="cursor-pointer"
                  isActive={currentPage === page}
                  onClick={e => {
                    e.preventDefault();
                    onPageClick(page);
                  }}
                >
                  {page}
                </PaginationLink>
              </PaginationItem>
            )
          )}

          <PaginationItem>
            <PaginationNext
              className="cursor-pointer"
              onClick={e => {
                e.preventDefault();
                if (currentPage < totalPages) onNextPage();
              }}
            />
          </PaginationItem>
        </PaginationContent>
      </Pagination>
    </div>
  );
}
